import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=1c20a6ce&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=1c20a6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20a6ce",
  null
  
)

export default component.exports